import {
	Building2,
	Globe,
	Headset,
	Mail,
	MessageSquareText,
	Share2,
	Store,
	type LucideIcon,
} from 'lucide-react'

import { type COMPLAINT_CHANNEL_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'

export type IntakeChannelValue =
	(typeof COMPLAINT_CHANNEL_OPTIONS)[number]['value']

const iconByValue: Record<IntakeChannelValue, LucideIcon> = {
	hotline: Headset,
	email: Mail,
	web_form: Globe,
	retailer_portal: Store,
	social_media: Share2,
	in_store: Building2,
	text: MessageSquareText,
}

export function getIntakeChannelIcon(value: IntakeChannelValue): LucideIcon {
	return iconByValue[value] ?? Headset
}
